<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="col-md-6" id="heading">
          <h6>Click & Navigate Form Details</h6>
        </div>
        <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
          <h6 id="siteId">Site Id: {{ siteId }}</h6>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Add / View Virtual Group for Site -->
    <mat-expansion-panel class="my-expansion" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title
          ><h6>Add / View Virtual Group for Site</h6></mat-panel-title
        >
      </mat-expansion-panel-header>
      <form [formGroup]="processForm" #formDirective="ngForm" novalidate>
        <div class="row">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input">Create New Virtual Group</mat-label>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input
                matInput
                formControlName="virtualGroupNamesCtr"
                [(ngModel)]="virtualGroupNames"
                placeholder=""
                required
              />
              <mat-error
                *ngIf="
                  processForm.get('virtualGroupNamesCtr').hasError('required')
                "
                >This field is required.</mat-error
              >
              <mat-error
                *ngIf="
                  processForm.get('virtualGroupNamesCtr').hasError('whitespace')
                "
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <button
              (click)="addNewVirtualGroupForSite()"
              class="button-primary alignbutton"
              bciprimarybutton
            >
              Add New Virtual Group
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <mat-table
            #tableM
            *ngIf="virtualGroupsConfiguredForSite.length > 0"
            [dataSource]="virtualGroupsConfiguredForSite"
            matSort
          >
            <ng-container matColumnDef="index">
              <mat-header-cell *matHeaderCellDef>Sl.No</mat-header-cell>
              <mat-cell *matCellDef="let item; let rIndex = index"
                >{{ rIndex + 1 }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="virtualGroup">
              <mat-header-cell *matHeaderCellDef>Virtual Group</mat-header-cell>
              <mat-cell *matCellDef="let item">{{ item }}</mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let item; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      </div>
    </mat-expansion-panel>

    <!-- Tree Configuration for Comparision Analysis and Click&Navigate -->
    <mat-expansion-panel class="my-expansion" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title
          ><h6>
            Tree Configuration for Comparision Analysis and Click&Navigate
          </h6></mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="row">
        <div
          class="col-xs-11 col-sm-11 col-md-11 col-lg-11"
          style="padding-left: 2%"
        >
          Apply Tree Configuration same as "Static Load Tree" :
          <mat-radio-button
            #radioYes
            value="true"
            (change)="copyToLayoutNavigationFeatureRadioChange('true')"
            >Yes</mat-radio-button
          >
          <mat-radio-button
            #radioNo
            value="false"
            (change)="copyToLayoutNavigationFeatureRadioChange('false')"
            [checked]="true"
            >No</mat-radio-button
          >
        </div>
      </div>
      <div class="row">
        <div
          class="col-xs-11 col-sm-11 col-md-11 col-lg-11"
          style="padding-left: 2%"
        >
          <mat-label
            ><br /><span class="colorRed"> * </span> Add Virtual Groups above
            Load Level</mat-label
          >
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          layoutNavigationFeatureTreeData === undefined ||
          layoutNavigationFeatureTreeData.length <= 0
        "
      >
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <button
            class="button-primary"
            bciprimarybutton
            (click)="initTree(treeType.LAYOUT_NAVIGATION_TREE)"
          >
            Initiate Tree
          </button>
        </div>
      </div>
      <div class="row"><br /></div>

      <div class="row">
        <div style="max-height: 650px; overflow-y: scroll">
          <mat-tree
            #tree
            [dataSource]="dataSource"
            [(treeControl)]="treeControl"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
          >
            <mat-tree-node
              class="site-tree-node"
              *matTreeNodeDef="let node"
              cdkDrag
              [cdkDragData]="node"
              (mouseenter)="dragHover(node)"
              (mouseleave)="dragHoverEnd()"
              (cdkDragStarted)="dragStart()"
              (cdkDragReleased)="dragEnd()"
              matTreeNodeToggle
              matTreeNodePadding
              (click)="activeNode = node"
            >
              <div class="row" style="width: 100%">
                <div class="col-md-8">
                  <button
                    type="button"
                    (click)="$event.preventDefault()"
                    bciprimarybutton
                    disabled
                  ></button>
                  <mat-label (click)="featureLeafItemSelectionToggle(node)">{{
                    node.title
                  }}</mat-label>
                </div>
                <div class="col-md-4" style="text-align: right">
                  <button
                    class="button-primary"
                    bciprimarybutton
                    [disabled]="node.loadRId !== undefined"
                    (click)="editNode(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="edit icon"
                        class="bosch-ic-edit"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                  &nbsp;
                  <button
                    class="button-primary"
                    bciprimarybutton
                    [disabled]="node.loadRId !== undefined"
                    (click)="newSubItem(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="add icon"
                        class="bosch-ic-add"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                  &nbsp;
                  <button
                    class="button-primary"
                    bciprimarybutton
                    (click)="removeNodeItem(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="weather icon"
                        class="bosch-ic-abort-frame"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                </div>
              </div>
            </mat-tree-node>

            <mat-tree-node
              class="site-tree-node"
              *matTreeNodeDef="let node; when: hasChild"
              cdkDrag
              [cdkDragData]="node"
              (mouseenter)="dragHover(node)"
              (mouseleave)="dragHoverEnd()"
              (cdkDragStarted)="dragStart()"
              (cdkDragReleased)="dragEnd()"
              matTreeNodePadding
              (click)="activeNode = node"
            >
              <div class="row" style="width: 100%">
                <div class="col-md-7">
                  <button
                    type="button"
                    (click)="$event.preventDefault()"
                    bciprimarybutton
                    matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.filename"
                  >
                    <mat-icon
                      *ngIf="treeControl.isExpanded(node)"
                      fontIcon="Bosch-Ic-arrow-expand-down"
                    ></mat-icon>
                    <mat-icon
                      *ngIf="!treeControl.isExpanded(node)"
                      fontIcon="Bosch-Ic-arrow-expand-right"
                    ></mat-icon>
                  </button>
                  <mat-label>{{ node.title }}</mat-label>
                </div>
                <div class="col-md-5" style="text-align: right">
                  <button
                    class="button-primary"
                    bciprimarybutton
                    [disabled]="node.loadRId !== undefined"
                    (click)="editNode(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="edit icon"
                        class="bosch-ic-edit"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                  &nbsp;
                  <button
                    class="button-primary"
                    bciprimarybutton
                    [disabled]="node.loadRId !== undefined"
                    (click)="newSubItem(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="add icon"
                        class="bosch-ic-add"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                  &nbsp;

                  <button
                    class="button-primary"
                    bciprimarybutton
                    (click)="removeNodeItem(node, treeType.LOAD_ON_TREE)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="weather icon"
                        class="bosch-ic-abort-frame"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                  </button>
                </div>
              </div>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"></div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <button
            type="submit"
            class="button-primary"
            bciprimarybutton
            (click)="saveTreeConfiguration()"
            style="margin-top: 4px"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-checkmark-frame"
                style="width: max-content"
              ></mat-icon> </span
            >Save
          </button>
        </div>
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"></div>
      </div>
    </mat-expansion-panel>
    <!-- Upload Image for Click&Navigate feature -->
    <mat-expansion-panel class="my-expansion" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title
          ><h6>Upload Image for Click&Navigate feature</h6></mat-panel-title
        >
      </mat-expansion-panel-header>
      <app-upload-image-configuration
        [data]="layoutNavigationFeatureTreeData"
        [parentSubject]="parentSubject"
        [siteId]="siteId"
      ></app-upload-image-configuration>
    </mat-expansion-panel>

    <!-- Commissioning Remarks -->
    <mat-expansion-panel class="my-expansion" expanded="false">
      <mat-expansion-panel-header>
        <mat-panel-title><h6>Commissioning Remarks</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <mat-label class="label-input">Commissioning Remarks</mat-label>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <textarea
            rows=""
            cols=""
            class="form-control alignbutton"
            placeholder="Commissioning Remarks"
            [(ngModel)]="commissionRemark"
            maxlength="300"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <button
            (click)="submitCommissionRemark()"
            class="button-primary alignbutton"
            bciprimarybutton
          >
            Save
          </button>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-action-row>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <button
          (click)="previousStep($event)"
          class="button-primary"
          bciprimarybutton
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-left-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Previous
        </button>
        <button
          type="submit"
          class="button-primary"
          bciprimarybutton
          style="margin-left: 3px"
          (click)="openSiteDetailReport()"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-print"
              style="width: max-content"
            ></mat-icon> </span
          >Print Project Details Form
        </button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
